import { render, staticRenderFns } from "./TabAlteracoes.vue?vue&type=template&id=0fa09715"
import script from "./TabAlteracoes.vue?vue&type=script&lang=js"
export * from "./TabAlteracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports